import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';

// Suppress noisy warnings from React/charts AND third-party browser extensions
// (Grammarly, jQuery injected by extensions) and YouTube IFrame API residuals.
// Pattern matching against the joined message + first arg.
const NOISE_PATTERNS = [
  'defaultProps',
  'width(-1) and height(-1) of chart',
  'Permissions policy violation: unload is not allowed',
  'Added non-passive event listener to a scroll-blocking',
  "'postMessage' on 'DOMWindow'",
  'Sizzle.setDocument',
  'Grammarly',
];

function isNoise(args: unknown[]): boolean {
  const text = args.map((a) => (typeof a === 'string' ? a : '')).join(' ');
  return NOISE_PATTERNS.some((p) => text.includes(p));
}

const originalConsoleWarn = console.warn;
console.warn = (...args) => {
  if (isNoise(args)) return;
  originalConsoleWarn(...args);
};

const originalConsoleError = console.error;
console.error = (...args) => {
  if (isNoise(args)) return;
  originalConsoleError(...args);
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);